import React from 'react';

interface PageLoaderProps {
  isLoading: boolean;
}

const PageLoader: React.FC<PageLoaderProps> = ({ isLoading }) => {
  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 bg-white/90 backdrop-blur-sm z-50 flex items-center justify-center pointer-events-none">
      <div className="text-center">
        {/* Animated logo */}
        <div className="relative mb-6">
          <img
            src="/logo.png"
            alt="Suitcase Muse"
            className="w-16 h-16 mx-auto animate-smooth-pulse object-contain"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-coral to-teal rounded-xl opacity-20 animate-smooth-ping"></div>
        </div>
        
        {/* Loading spinner */}
        <div className="flex justify-center mb-4">
          <div className="relative">
            <div className="w-8 h-8 border-4 border-gray-200 rounded-full"></div>
            <div className="w-8 h-8 border-4 border-coral border-t-transparent rounded-full animate-spin absolute top-0"></div>
          </div>
        </div>
        
        {/* Loading text */}
        <p className="text-gray-600 font-medium">Loading your style journey...</p>
      </div>
    </div>
  );
};

export default PageLoader;
